<tyl-form-field label='Amount' style="width: 170px;margin-right: 20px;" floatLabel="always">
    <input #txtAmount matInput id='inpAmount{{localId}}' [maxPrecision]="2" name='Amount{{localId}}' type='text' placeholder="0.00"
    [(ngModel)]='formattedAmount' (focus)="onFocus()" (keyup)="onChange()" required (blur)="onBlur()" />
    <span matPrefix>$&nbsp;</span>
</tyl-form-field>